/**
 *  External Modules
 */

import Vue from "vue";
import { createAuth0Client } from "@auth0/auth0-spa-js";

/**
 *  Vue.js Instance Definition
 */

let instance: any;

export const getInstance = () => instance;

/**
 *  Vue.js Instance Initialization
 */

export const useAuth0 = ({
  onRedirectCallback = () =>
    window.history.replaceState({}, document.title, window.location.pathname),
  redirectUri = window.location.origin,
  ...pluginOptions
}) => {
  if (instance) return instance;

  instance = new Vue({
    data() {
      return {
        auth0Client: null,
        isLoading: true,
        isAuthenticated: false,
        user: {},
        error: null
      };
    },
    methods: {
      loginWithRedirect(options: any) {
        // @ts-ignore
        return this.auth0Client.loginWithRedirect(options);
      },
      // @ts-ignore
      logout(options) {
        // @ts-ignore
        return this.auth0Client.logout(options);
      },
      // @ts-ignore
      getIdTokenClaims(o) {
        // @ts-ignore
        return this.auth0Client.getIdTokenClaims(o);
      },
      // @ts-ignore
      getAccessTokenSilently(o) {
        // @ts-ignore
        return this.auth0Client.getTokenSilently(o);
      }
    },

    async created() {
      // @ts-ignore
      this.auth0Client = await createAuth0Client({
        ...pluginOptions,
        domain: pluginOptions.domain,
        clientId: pluginOptions.clientId,
        authorizationParams: {
          audience: pluginOptions.audience,
          redirect_uri: redirectUri,
          scope: pluginOptions.scope
        }
      });

      try {
        const search = window.location.search;

        if (
          (search.includes("code=") || search.includes("error=")) &&
          search.includes("state=")
        ) {
          // @ts-ignore
          const { appState } = await this.auth0Client.handleRedirectCallback();
          // @ts-ignore
          onRedirectCallback(appState);
        }
      } catch (error) {
        // @ts-ignore
        this.error = error;
      } finally {
        // @ts-ignore
        this.isAuthenticated = await this.auth0Client.isAuthenticated();
        // @ts-ignore
        this.user = await this.auth0Client.getUser();
        this.isLoading = false;
      }
    }
  });

  return instance;
};

/**
 *  Vue.js Plugin Definition
 */

export const Auth0Plugin = {
  // @ts-ignore
  install(Vue, options) {
    Vue.prototype.$auth0 = useAuth0(options);
  }
};
